import type { PreloadFetchPolicy } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import ProjectPickerAtlasQuery from './__generated__/ProjectPickerAtlasQuery.graphql';

type EntryPointParams = { cloudId: string };
const fetchPolicy: PreloadFetchPolicy = 'store-or-network';

export const projectPickerEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_@atlassian/project-picker/project-picker/ProjectPicker" */ './ProjectPicker'
			).then(({ ProjectPickerWithEntrypoint }) => ProjectPickerWithEntrypoint),
		{
			moduleId: 'project-picker-entrypoint',
		},
	),
	getPreloadProps: ({ cloudId }: EntryPointParams) => ({
		queries: {
			projectPickerQuery: {
				parameters: ProjectPickerAtlasQuery,
				variables: {
					cloudId,
				},
				options: {
					fetchPolicy,
				},
			},
		},
	}),
});
